
window.Vivense = window.Vivense || {};

Vivense.registrationPopup = (function($) {

    var exports = {}, form, afterSuccessFunc;

    function genericError() {
        Vivense.loginPopup.enableAllButtons();
        Vivense.validateError('Bir hata oluştu, lütfen tekrar deneyin.');
    }

    function displayRegistrationError(data) {
        Vivense.loginPopup.enableAllButtons();
        Vivense.loginPopup.displayLoginError(data);
    }

    function gtaEvent(){
        dataLayer.push({
            'Category':'Membership',
            'Action':'Signup ',
            'Label':' Successful / Manuel',
            'event':'gaEvent'
        });
    }

    function pushFormErrorGtaEvent(message){
        dataLayer.push({
            'Category':'Membership',
            'Action':'Signup Error',
            'Label': message,
            'event':'gaEvent'
        });
    }

    function finishSuccessfulRegistration() {
        if (window.currentPage === "cartOrderFinal"){ // Soft registration
            Vivense.populate.insertEvent("softRegistration", window.currentPage, "self", "softRegistration", 2, afterSuccessFunc);
            Vivense.cookie.set("softRegistered","1", 5/60); // 5 minutes cookie for soft registered
        } else {

            if ($.inArray(Vivense.popupAction, ['header','footer','welcome_coupon_1']) > -1){
                Vivense.cookie.set("showCouponModal","1", 1/60); // 1 minutes cookie for show coupon modal
            }

            Vivense.populate.insertEvent(Vivense.popupScenario, window.currentPage, Vivense.popupAction, "membership", 2, afterSuccessFunc);
        }
    }

    function handleEmailRegistrationResult(data, textStatus, jqXHR) {
        if(window.currentPage === "cartOrderFinal" && data.status){
            finishSuccessfulRegistration();
        }

        if ( ! data.success) {
            displayRegistrationError(data);
            pushFormErrorGtaEvent(data.error);
            return;
        }

        gtaEvent();

        finishSuccessfulRegistration();
    }

    function submitForm(e) {

        e.preventDefault();

        $(".failed-login-wrapper").removeClass("failed-login");

        if (!userPopupActionValidation(form)) {

            var emailValidationEl = $(".email-validation");
            var passwordValidationEl = $(".password-validation");
            var kvkkValidationEl = $(".checkbox-validation");

            if(emailValidationEl.length && emailValidationEl.text()){
                pushFormErrorGtaEvent(emailValidationEl.text());
            }

            if (passwordValidationEl.length && passwordValidationEl.text()){
                pushFormErrorGtaEvent(passwordValidationEl.text());
            }

            if(kvkkValidationEl.length){
                pushFormErrorGtaEvent("Kvkk onaylanmadı.");
            }

            return false;
        }

        Vivense.loginPopup.disableAllButtons();

        var formData = form.serializeArray();
        Vivense.loginPopup.addStandardParameters(formData);

        $.post(form.attr('action'), $.param(formData))
            .done(handleEmailRegistrationResult)
            .fail(genericError);
    }

    function getRegistrationForm() {
        return form;
    }

    function init() {
        afterSuccessFunc = function () {
            window.location.reload();
        };

        form = $('#registrationForm');
        form.on('submit', submitForm);

    }

    $(document).ready(init);

    exports.getRegistrationForm = getRegistrationForm;
    exports.afterSuccessFunc = afterSuccessFunc;

    return exports;

})(jQuery);
